export const STEP_LABELS: Record<string, string> = {
  'book-info': 'Getting Started',
  'book-form-factor': 'Choosing Format',
  'book-formatting': 'Formatting',
  'book-preview': 'Previewing',
  'book-cover': 'Cover Design',
  'pricing': 'Pricing',
};

export const stepLabel = (step: string): string => STEP_LABELS[step] || step;

export const MANUSCRIPT_LABELS: Record<string, string> = {
  pdf: 'PDF uploaded',
  docx: 'DOCX uploaded',
  other: 'File uploaded',
  typed: 'Typing in editor',
  none: 'No manuscript yet',
};

export const SALES_STATUS_LABELS: Record<string, string> = {
  not_contacted: 'Not Contacted',
  contacted: 'Contacted',
  follow_up: 'Follow Up',
  not_interested: 'Not Interested',
};

// Light badge style — used for read-only status pills (table, sidebar list).
export const SALES_STATUS_BADGE_STYLES: Record<string, string> = {
  not_contacted: 'bg-gray-100 text-gray-600',
  contacted: 'bg-blue-50 text-blue-700',
  follow_up: 'bg-amber-50 text-amber-700',
  not_interested: 'bg-red-50 text-red-700',
};

// Status picker chips — each status keeps its own color whether selected or
// not (light outline unselected, filled when selected), so the options are
// visually distinct at a glance rather than all looking the same until picked.
export const SALES_STATUS_CHIP_STYLES: Record<string, { selected: string; unselected: string }> = {
  not_contacted: {
    selected: 'bg-gray-700 text-white border-gray-700',
    unselected: 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50',
  },
  contacted: {
    selected: 'bg-blue-600 text-white border-blue-600',
    unselected: 'bg-white text-blue-600 border-blue-300 hover:bg-blue-50',
  },
  follow_up: {
    selected: 'bg-amber-500 text-white border-amber-500',
    unselected: 'bg-white text-amber-600 border-amber-300 hover:bg-amber-50',
  },
  not_interested: {
    selected: 'bg-red-600 text-white border-red-600',
    unselected: 'bg-white text-red-600 border-red-300 hover:bg-red-50',
  },
};

// Solid dot indicator for the stat tile row — same hues as the chips/badges
// above (status color paired with an icon + label, never carrying meaning
// by hue alone), just a plain swatch rather than a full badge.
export const SALES_STATUS_DOT_STYLES: Record<string, string> = {
  not_contacted: 'bg-gray-400',
  contacted: 'bg-blue-600',
  follow_up: 'bg-amber-500',
  not_interested: 'bg-red-600',
};

export const SALES_STATUS_OPTIONS = [
  { value: '', label: 'All Contact Statuses' },
  { value: 'not_contacted', label: SALES_STATUS_LABELS.not_contacted },
  { value: 'contacted', label: SALES_STATUS_LABELS.contacted },
  { value: 'follow_up', label: SALES_STATUS_LABELS.follow_up },
  { value: 'not_interested', label: SALES_STATUS_LABELS.not_interested },
];

export const STEP_OPTIONS = [
  { value: '', label: 'All Stages' },
  ...Object.entries(STEP_LABELS).map(([value, label]) => ({ value, label })),
];

export const BOOK_STATUS_OPTIONS = [
  { value: '', label: 'All Book Statuses' },
  { value: 'draft', label: 'Draft' },
  { value: 'submitted', label: 'Submitted' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
];

export type SortField = 'name' | 'phoneNumber' | 'updatedAt' | 'salesUpdatedAt';
export type SortDir = 'asc' | 'desc';
